import React from "react";
import { Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";

import {
  updateUI,
  updateSingleStateRequest,
  singleCancelRequest,
} from "../../store/actions/shipment";

function CancelStateShipment() {
  const dispatch = useDispatch();
  const { isUpdateStateOpen, currentUpdateState } = useSelector((state) => ({
    isUpdateStateOpen: state.shipment.ui.cancel.singleCancel,
    currentUpdateState: state.shipment.ui.cancel.cancelField,
  }));

  const handleOk = () => {
    dispatch(
      singleCancelRequest({
        singleCancel: false,
      })
    );
  };
  const handleCancel = () => {
    dispatch(
      updateUI({
        key: "cancel",
        value: {
          singleCancel: !isUpdateStateOpen,
          cancelField: currentUpdateState,
        },
      })
    );
  };

  return (
    <Modal
      className="d-flex flex-column justify-content-center align-items-center p-2 bulk-shipment-edit"
      title=""
      open={isUpdateStateOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      width={{
        xs: "90%",
        sm: "80%",
        md: "70%",
        lg: "68%",
        xl: "65%",
        xxl: "60%",
      }}
      footer={[
        <button
          key="back"
          className="font-face-vzw cancel"
          onClick={handleCancel}
          style={{
            fontSize: "16px",
            fontWeight: 700,
          }}
        >
          No, keep
        </button>,
        <button
          key="submit"
          className="font-face-vzw update"
          onClick={handleOk}
          style={{
            fontSize: "16px",
            fontWeight: 700,
          }}
        >
          Yes, cancel
        </button>,
      ]}
    >
      <div className="py-2">
        <div
          className="font-face-vzw"
          style={{
            fontWeight: 700,
            fontSize: "30px",
          }}
        >
          Cancel Shipment
        </div>
      </div>
      <div>
        <div className="d-flex flex-column justify-content-center align-items-start py-2">
          <div
            style={{
              fontWeight: 400,
              fontSize: "17px",
              fontFamily: "VerizonNHGDS",
            }}
          >
            Are you sure you want to cancel the shipment{" "}
            <b
              className="font-face-vzw"
              style={{ fontWeight: 700, fontSize: "16px" }}
            >
              {currentUpdateState?.name}
            </b>{" "}
           ?
          </div>
          <span
            style={{
              fontWeight: 400,
              fontSize: "17px",
              fontFamily: "VerizonNHGDS",
            }}
          >
          By cancelling the shipment, you will archive the data associated with the
          shipment.
          </span>
        </div>
      </div>
    </Modal>
  );
}

export default CancelStateShipment;
